export default __webpack_public_path__ + "f249a9deb44a7b3c2573681fc884f3a9.png";